// @ts-nocheck
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    DispatchLoadWishListLinesIfNeeded,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { ApiHandlerDiscreteParameter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<{ wishListId: string }, GetWishListsApiParameter, OrderModel>;

export const DispatchLoadWishListLinesIfNeededWithLocalStoragePersistance: HandlerType = props => {
    const savedSortBy = localStorage.getItem("wishListDetailSortBy");
    const defaultParameter = {
        wishListId: props.parameter.wishListId,
        defaultPageSize: props.getState().context.settings.settingsCollection.wishListSettings.productsPerPage,
        query: "",
    };
    if (!savedSortBy) {
        props.dispatch(updateLoadWishListLinesParameter(defaultParameter));
    } else {
        props.dispatch(updateLoadWishListLinesParameter({ ...defaultParameter, sort: savedSortBy }));
    }

    props.dispatch(loadWishListLines());
};
replaceInChain(chain, DispatchLoadWishListLinesIfNeeded, DispatchLoadWishListLinesIfNeededWithLocalStoragePersistance);
